/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getProjectPrioritySchema = z.object({
  id: z.coerce.number().int().optional(),
  name: z.coerce.string(),
});
